import { createApp } from 'vue';
import { installPlatformCanvasHost } from './designer/platform-canvas-host';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { i18n, currentLocale } from './i18n';
// Streaming-markdown renderer styles (chat). Imported before our own styles so
// the `.stream-markdown` token overrides in styles.css take precedence.
import 'vue-stream-markdown/index.css';
import 'vue-stream-markdown/theme.css';
import 'katex/dist/katex.min.css';
import './styles.css';

document.documentElement.setAttribute('lang', currentLocale());
installPlatformCanvasHost(createApp(App)).use(router).use(createPinia()).use(i18n).mount('#app');
